import thumbnail from './halfdonut_thumb.svg';

export const metadata = {
  name: 'global.section.chartselection.halfdonutchart.title',
  id: 'halfdonutchart',
  thumbnail,
  icon: 'fa-rainbow',
  categories: ['categories.proportions'],
  description: 'global.section.chartselection.halfdonutchart.description',
  code: '',
  tutorial: '',
};
